import { withStyles, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import LocaleKeys from '../../../../locales/keys';
import { Grid, Button, Box, NativeSelect, Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  box: {
    marginTop: '32px',
    marginBottom: '16px', // 24px with the 8px of the dialog content
    borderRadius: '8px',
    border: '1px solid rgba(247, 244, 241, 0.12)',
    background: '#27272F',
    [theme.breakpoints.up('lg')]: {
      width: '552px',
    },
  },
  title: {
    fontFamily: 'Formula1-Regular',
    fontSize: '16px',
    lineHeight: '16px',
    letterSpacing: '.5px',
    fontWeight: 400,
    color: '#FFF',
    textAlign: 'center',
    marginTop: '24px',
  },
  message: {
    marginTop: '16px',
    color: '#FFF',
    textAlign: 'center',
    fontFamily: 'TitilliumWeb-Regular',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
    letterSpacing: '0.5px',
  },
  terminationReasonSelect: {
    width: '320px',
    height: '40px',
    marginTop: '24px',
    '&.MuiInputBase-root': {
      borderRadius: theme.spacing(1),
      border: `1px solid ${theme?.palette?.custom?.lightBlack}`,
      '&.Mui-focused': {
        boxShadow: '0 0 10px #9ecaed',
      },
    },
    '& .MuiNativeSelect-select': {
      height: '50%',
    },
  },
  continueCancellationCTA: {
    marginTop: '24px',
    marginBottom: '24px',
    padding: '0px',
    borderRadius: '0px',
    lineHeight: '16px',
    height: '20px',
    fontSize: '15px',
    color: '#FFF',
    borderBottom: '2px solid #E10600',
  },
}));

const RetentionNotForYouBox = (props) => {
  const { continueCancellationAction, terminationReasons } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const [terminationReason, setTerminationReason] = useState(undefined);
  const [filteredTerminationReasons, setFilteredTerminationReasons] = useState(
    [],
  );

  const defaultCancellationIdentifier =
    ASCENDON_ENV_CONFIG.retentionConfiguration?.defaultCancellationIdentifier;

  useEffect(() => {
    if (terminationReasons) {
      setFilteredTerminationReasons(
        terminationReasons.filter(
          (item) => item.Description !== defaultCancellationIdentifier,
        ),
      );
    }
  }, [terminationReasons]);

  const DialogButtonAction = withStyles(classes)((props) => {
    const { children, classes, handleClose, ...other } = props;
    return (
      <Button
        autoFocus
        className={`${classes.button} ${classes.closeButtonContent}`}
        onClick={handleClose}
        {...other}
      >
        {children}
      </Button>
    );
  });

  return (
    <Box className={classes.box}>
      <Grid container direction="row" justifyContent="center" xm={0}>
        <Typography className={classes.title} variant="body2" display="block">
          {t(LocaleKeys.retention.notForYouTitle)}
        </Typography>
      </Grid>
      <Grid container direction="row" justifyContent="center" xm={0}>
        <Typography className={classes.message} variant="body2" display="block">
          {t(LocaleKeys.retention.sorryToSeeYouGo)}
        </Typography>
      </Grid>
      <Grid container direction="row" justifyContent="center" xm={0}>
        <NativeSelect
          fullWidth
          className={classes.terminationReasonSelect}
          disableUnderline
          name="terminationReason"
          value={terminationReason}
          onChange={(event) => {
            setTerminationReason(event.target.value);
          }}
          defaultValue="empty"
        >
          <option value="empty" disabled>
            {t(LocaleKeys.retention.terminationReason)}
          </option>
          {filteredTerminationReasons?.length ? (
            filteredTerminationReasons.map((terminationReason, key) => (
              <option value={terminationReason.Value} key={key}>
                {terminationReason.Name}
              </option>
            ))
          ) : (
            <></>
          )}
        </NativeSelect>
      </Grid>
      <Grid container direction="row" justifyContent="center" xm={0}>
        <DialogButtonAction
          size="large"
          style={{
            fontWeight: 600,
            textTransform: 'none',
            padding: '0px',
            marginTop: '16px',
            marginBottom: '16px',
            borderRadius: '0px',
            height: '20px',
            fontSize: '15px',
            color: '#FFF',
            borderBottom: '2px solid #E10600',
          }}
          handleClose={() => {
            if (continueCancellationAction) {
              if (terminationReason) {
                continueCancellationAction(terminationReason);
              } else {
                const defaultTerminationReason = terminationReasons?.find(
                  (candidate) => candidate?.Description === 'Default',
                );
                continueCancellationAction(defaultTerminationReason);
              }
            }
          }}
        >
          {t(LocaleKeys.retention.continueCancellation)}
        </DialogButtonAction>
      </Grid>
    </Box>
  );
};

export default RetentionNotForYouBox;
